import { useCallback } from "react";

import { isInIframe } from "helpers/app";

import { useMessenger } from "./use-messenger";

interface IUseIframeNavigateTo {
  navigateTo: (path: string) => void;
}

export const useIframeNavigateTo = (): IUseIframeNavigateTo => {
  const embeddedInIframe = isInIframe();

  const { sendMessage } = useMessenger<
    {
      type: "router:navigate:sync";
      payload: { path: string };
    },
    unknown
  >(() => {});

  const navigateTo = useCallback(
    (path: string) => {
      if (embeddedInIframe) {
        sendMessage({ type: "router:navigate:sync", payload: { path } });
      }
    },
    [sendMessage, embeddedInIframe]
  );

  return { navigateTo };
};
